__turbopack_context__.v({
  "placeholder": "rjYEIG_placeholder",
  "root": "rjYEIG_root",
});
